import { TableSkeleton, TableSkeletonProps } from '~/components/TableSkeleton/TableSkeleton';

export const ChatSkeleton = (props: TableSkeletonProps) => {
  return <TableSkeleton {...props} />;
};
